import { useSearchParams } from "@shared/react-router-dom";

const useUnauthUrlFields = () => {
  const [searchParams] = useSearchParams();

  const payload = {
    utm_campaign: searchParams?.get("utm_campaign"),
    utm_medium: searchParams?.get("utm_medium"),
    utm_source: searchParams?.get("utm_source"),
    utm_id: searchParams?.get("utm_id"),
    utm_term: searchParams?.get("utm_term"),
    utm_content: searchParams?.get("utm_content"),
    utm_channel: searchParams?.get("utm_channel"),
    utm_adgroup: searchParams?.get("utm_adgroup"),
    utm_matchtype: searchParams?.get("utm_matchtype"),
    utm_device: searchParams?.get("utm_device"),
  };

  Object.keys(payload).forEach(key => {
    if (payload[key] === null || payload[key] === undefined) {
      delete payload[key];
    }
  });

  return payload;
};

export { useUnauthUrlFields };
